const dataPlanExtension = {
  dataPlanExtension: {
    heading: "Rozszerzenie Danych Mobilnego Połączenia",
    cellModemIMEI: "Numer IMEI modemu komórkowego",
    siteName: "Nazwa systemu",
    siteAddress: "Adres systemu",
    cellPlanEndDate: "Data zakończenia planu modemu komórkowego",
    daysToExpiry: "Dias até à expiração",
    currentPlanStatus: "Estado atual do plano",
    gatewaySNo: "N.º de gateway",
    paymentStatus: "Estado de pagamento",
    lastDateOfPurchase: "Última data de compra",
    extendDataPlan: "Plano de dados alargado",
    purchasedBy: "Comprado por",
    purchasedFrom: "Comprado de",
    siteId: "Identyfikator systemu",
    orderNo: "numer zamówienia",
    footer: 'Rozszerzenie Danych Mobilnego Połączenia',
    total: 'Total',
    record: 'registos',
    records: 'registos',
    show: 'Mostrar',
    enphase_store: 'Enphase Store',
    orderSummary: 'Resumo da encomenda.',
    confirmSelection: 'Por favor, confirme a sua seleção abaixo',
    noOfCellModems: 'Número de modems celulares',
    years: 'Anos',
    pricePerSite: 'Preço por sítio',
    cancel:'Cancelar',
    submit:'Enviar',
    back: 'Voltar',
    noTokens: '** Não há modems celulares disponíveis **',
    redirectToStoreText: 'Przekierowanie do Enphase Store! Proszę czekać...!',
    toolTipExtensionInfo: 'Do przedłużenia kwalifikują się tylko plany dotyczące modemów komórkowych, których ważność wygaśnie mniej niż 180 dni.',
    allCellModems: 'Wszystkie modemy komórkowe',
    dataplanTitleTooltip: 'This is an extension to Enphase monitoring, software/firmware upgrades, and other remote services offered via your existing AT&T cell modem. This extension will enable you to continue using the same physical hardware, beyond its 5-year term you had originally purchased, by renewing its connectivity instead of having to purchase a new physical device.', 
    eligibleCellModems: 'Kwalifikujące się modemy komórkowe',
    nonAdminInfo: 'Skontaktuj się z administratorem, aby rozszerzyć pakiet danych dla modemu komórkowego',
    select: 'Wybierać',
    typeToSearch: 'Wpisz aby wyszukać',
    dataPlanExtensionSuccess: "Rozszerzenie danych mobilnego połączenia się. Może upłynąć trochę czasu, zanim płatność zostanie odzwierciedlona na pulpicie nawigacyjnym",
    expired: 'Wygasły',
    active: 'Aktywny',
    failed: "Płatność nie powiodła się",
    pending: "Przetwarzanie płatności",
    success: "Płatność pomyślna",
  }
}

export default dataPlanExtension